import React from 'react';
import styles from './DebateCard.module.css';
import {
  HiUserGroup, HiPlayCircle, HiCurrencyDollar, HiTrophy, HiClock
} from 'react-icons/hi2';
import { useTranslation } from 'react-i18next';

export default function DebateCard({ data }) {
  const {
    title, role, status, wager, earned, outcome, date
  } = data;
  const { t } = useTranslation();
  const outcomeColor = outcome === 'win' ? styles.win :
                       outcome === 'loss' ? styles.loss : styles.pending;

  const statusColor = status === 'live' ? styles.live :
                      status === 'upcoming' ? styles.upcoming : styles.past;

  return (
    <div className={`${styles.card} ${statusColor}`}>
      <h4 className={styles.title}>{title}</h4>

      <div className={styles.infoRow}>
        <HiClock className={styles.icon} />
        <span>{date}</span>
      </div>

      <div className={styles.infoRow}>
        <HiUserGroup className={styles.icon} />
        <span>{t(`debates.role.${role}`)}</span>
      </div>

      <div className={styles.infoRow}>
        <HiCurrencyDollar className={styles.icon} />
        <span>{t('debates.wager')}: {wager}</span>
      </div>

      {earned != null && (
        <div className={styles.infoRow}>
          <HiTrophy className={styles.icon} />
          <span>{t('debates.earned')}: {earned}</span>
        </div>
      )}

      <div className={`${styles.outcome} ${outcomeColor}`}>
        {t(`debates.outcome.${outcome}`)}
      </div>
    </div>
  );
}
